export const lastEmailKey = "lastEmail";